<template>
  <div class="SiteNavHamburger" ref="SiteNav">

    <div class="header">
      <div class="wrapper">
        <div class="navToggle" role="button" tabindex="0" @click="handleNav" :class="{open:navOpen}"><span></span><span></span><span></span></div>
        <transition name="vFade">
          <div class="head" role="button" tabindex="0" @click="handleHomeLink">
            <img src="/assets/ui/mike-head.svg" alt="Mike Cassie">
          </div>
        </transition>
      </div>
    </div>

    <transition name="vFade">
      <div class="overlayMenu" ref="overlayMenu" v-show="navOpen" @click="closeMenu">
        <div class="wrapper">
          <nav>
            <router-link :to="{ name: 'Digital' }">
              <div class="title">Digital</div>
              <div class="descrip">Case studies of recent digital projects</div>
            </router-link>
            <router-link :to="{ name: 'Other' }">
              Other
              <div class="descrip">Painting, architecture and board game design</div>
            </router-link>
            <router-link :to="{ name: 'About' }">
              About
              <div class="descrip">My skills and experience</div>
            </router-link>
          </nav>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { throttle } from 'lodash'

export default {
  name: 'SiteNavHamburger',
  data() {
    return {
      navScrolled: false,
      navOpen: false
    }
  },
  props: {
    isHome: {
      type: Boolean,
      default: null
    }
  },
  created () {
    this.scrollThrottle = throttle(this.navScroll, 300)
    window.addEventListener('scroll', this.scrollThrottle)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollThrottle)
  },
  methods: {
    navScroll() {
      let currentScroll = window.pageYOffset
      if ( currentScroll > 40) {
        this.$refs.SiteNav.classList.add('scrolled')
        this.navScrolled = true
      } else if (currentScroll < 40) {
        this.$refs.SiteNav.classList.remove('scrolled')
        this.navScrolled = false
      }
    },
    handleHomeLink() {
      if (this.navOpen == true) {
        this.$refs.overlayMenu.classList.add('closing')
        this.navOpen = false
      }
      this.$router.push({ name: 'Home' })
    },
    handleNav() {
      if (this.navOpen) {
        this.$refs.overlayMenu.classList.add('closing')
        this.navOpen = false
      } else {
        this.$refs.overlayMenu.classList.remove('closing')
        this.navOpen = true
      }
    },
    closeMenu() {
      this.$refs.overlayMenu.classList.add('closing')
      this.navOpen = false
    }
  }
}
</script>

<style scoped lang="scss">
.SiteNavHamburger {
  position: relative;

  & > .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 50;
    background: rgba(255,255,255,0);
    border-bottom: 1px solid transparent;
    transition: all 300ms;

    & .wrapper {
      @include siteWrapper;
      position: relative;
      height: 100px;
      transition: all 300ms;

      & .head {
        height: 70px;
        width: 70px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
        will-change: height, width, border-radius;
        cursor: pointer;
        transition: all 300ms;

        &:focus {
          outline: none;
        }

        & img {
          position: absolute;
          height: 100%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          will-change: height;
          transition: all 300ms;
        }
      }
      & .navToggle {
        height: 24px;
        width: 24px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        transition: all 200ms;
        cursor: pointer;

        &:focus {
          outline: none;
        }

        & span {
          display: block;
          width: 24px;
          height: 4px;
          background: #000;
          position: absolute;
          left: 0;
          transform-origin: center;
          opacity: 1;
          transition: all 200ms;

          &:nth-child(1) {
            top: 3px;
            // animation: closeOne 500ms 1;
          }
          &:nth-child(2) {
            top: 10px;
          }
          &:nth-child(3) {
            top: 17px;
          }

        }
        @keyframes closeOne {
          from {transform: rotate(45deg) scaleX(0);}
          to {transform: rotate(45deg) scaleX(1);}
        }
        @keyframes closeTwo {
          from {transform: rotate(135deg) scaleX(0);}
          to {transform: rotate(135deg) scaleX(1);}
        }
        &:hover {
          & span {
            &:nth-child(1) {
              top: 0;
              // animation: closeOne 500ms 1;
            }
            &:nth-child(2) {
              top: 10px;
            }
            &:nth-child(3) {
              top: 20px;
            }
          }
        }
        // open toggle
        &.open {
          & span {

            &:nth-child(1) {
              top: 13px;
              transform: rotate(45deg);
            }
            &:nth-child(2) {
              opacity: 0;
            }
            &:nth-child(3) {
              top: 13px;
              transform: rotate(135deg);
            }

          }
        }
      }
    }
  }

  & .overlayMenu {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 40;
    background: rgba(255,255,255,0.9);

    & .wrapper {
      @include siteWrapper;

      & > nav {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 30px 0 0 0;
  
        & > a {
          color: #000;
          @include fontBodyHead;
          text-decoration: none;
          font-size: 22px;
          text-transform: uppercase;
          position: relative;

          & .descrip {
            font-size: 14px;
            line-height: 20px;
            @include fontBody;
            text-transform: none;
            margin: 5px 0 0 0;
          }
  
          &::after {
            content: '';
            position: absolute;
            // left: 50%;
            // transform: translateX(-50%);
            bottom: 0;
            left: 0;
            width: 1%;
            height: 1px;
            background: #fff;
            transition: all 300ms;
          }
  
          &.router-link-exact-active, &:hover {
            color: #000;
  
            &::after {
              width: 100%;
              background: #000;
            }
          }
          &:nth-child(1) {
            animation: link1 500ms 1 forwards;
          }
          &:nth-child(2) {
            animation: link2 500ms 1 forwards;
          }
          &:nth-child(3) {
            animation: link3 500ms 1 forwards;
          }
          &:nth-child(4) {
            animation: link4 500ms 1 forwards;
          }
          @keyframes link1 {
            from {top: 0;}
            to {top: 80px;}
          }
          @keyframes link2 {
            from {top: 0;}
            to {top: 150px;}
          }
          @keyframes link3 {
            from {top: 0;}
            to {top: 220px;}
          }
          @keyframes link4 {
            from {top: 0;}
            to {top: 290px;}
          }
        }
      }
    }
    &.closing {
        & .wrapper {
          & > nav {
            & > a {
              &:nth-child(1) {
                animation: linkOff1 500ms 1 forwards;
              }
              &:nth-child(2) {
                animation: linkOff2 500ms 1 forwards;
              }
              &:nth-child(3) {
                animation: linkOff3 500ms 1 forwards;
              }
              &:nth-child(4) {
                animation: linkOff4 500ms 1 forwards;
              }
              &:nth-child(5) {
                animation: linkOff5 500ms 1 forwards;
              }
              @keyframes linkOff1 {
                from {top: 80px;}
                to {top: 0;}
              }
              @keyframes linkOff2 {
                from {top: 140px;}
                to {top: 0;}
              }
              @keyframes linkOff3 {
                from {top: 200px;}
                to {top: 0;}
              }
              @keyframes linkOff4 {
                from {top: 260px;}
                to {top: 0;}
              }
              @keyframes linkOff5 {
                from {top: 320px;}
                to {top: 0;}
              }
            }
          }
        }
      }
  }

  // scrolled version
  &.scrolled {
    & > .header {
      border-bottom: 1px solid #000;
      background: rgba(255,255,255,0.9);

      & .wrapper {
        height: 70px;

        & .head {
          height: 50px;
          width: 50px;
        }
      }
    }
  }
}
</style>
